import { useState } from 'react';
import type { Report } from '../../types';
import api from '../../shared/services/api/api';
import { useTranslation } from 'react-i18next';
import ReportMessage from './ReportMessage';
import GenerateOrDownload from './GenerateOrDownload';
import InputWrapper from '../forms/InputWrapper';
import Message from '../forms/Message';

type ReportStudioProps = {
  report: Report;
  patientId: string;
};

const ReportStudio = ({ report, patientId }: ReportStudioProps) => {
  const { t } = useTranslation();
  const [reportPdf, setReportPdf] = useState<{ data: string; message: string } | null>(null);
  const [error, setError] = useState<string | null>(null);

  const handleDownloadReport = async (code: string) => {
    const response = await api.generateReport({ code, patientId });
    if (response.data === null && response.error === -1) {
      setError(response.message);
      return;
    }
    setReportPdf(response);
  };

  return (
    <div>
      <ReportMessage message={reportPdf?.message} />
      <div className="max-w-xl">
        <GenerateOrDownload
          handler={() => handleDownloadReport(report?.codice)}
          link={reportPdf?.data}
          handlerLabel={t('generate studio report')}
          linkLabel={t('download studio report')}
        />
        <InputWrapper>
          <Message error={error} html />
        </InputWrapper>
      </div>
    </div>
  );
};

export default ReportStudio;
